const uniqueDomainsCounterSession = session => {
  const domains = [...session.pages, session.page]
  const uniqueDomains = new Set(domains.map(e => e.url))
  return uniqueDomains.size
}

module.exports = uniqueDomainsCounterSession
